import { render } from "./FlexContainer.vue?vue&type=template&id=070e1cbb&scoped=true"
import script from "./FlexContainer.vue?vue&type=script&lang=js"
export * from "./FlexContainer.vue?vue&type=script&lang=js"

import "./FlexContainer.vue?vue&type=style&index=0&id=070e1cbb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-070e1cbb"

export default script